{
    "NavigationNext": "Volgende",
    "NavigationPrevious": "Vorig",
    "ApplicationUservoice": "https:\/\/akixi.uservoice.com",
    "ApplicationDefaultDirectory": "\/CCS\/Stijlen\/Afbeeldingen\/Akixi2019\/",
    "NAME": "LanguageGeneral"
}